import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/HomePage";
import CareersPage from "./pages/CareersPage";
import EventsPage from "./pages/EventsPage";
import GetStartedPage from "./pages/GetStartedPage";
import ThankYouPage from "./pages/ThankYouPage";
import RetentionAnalysisPage from "./pages/RetentionAnalysisPage";
import RetentionProgramsPage from "./pages/RetentionProgramsPage";
import HowItWorksPage from "./pages/HowItWorksPage";
import EmployeeExperiencePage from "./pages/EmployeeExperiencePage";
import CityWorthStoryPage from "./pages/CityWorthStoryPage";
import RetentionCalculatorPage from "./pages/RetentionCalculatorPage";
import BookACallPage from "./pages/BookACallPage";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/sonner";
import { HelmetProvider } from "react-helmet-async";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/careers" element={<CareersPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/get-started" element={<GetStartedPage />} />
          <Route path="/thank-you" element={<ThankYouPage />} />
          <Route path="/retention-analysis" element={<RetentionAnalysisPage />} />
          <Route path="/retention-programs" element={<RetentionProgramsPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/employee-experience" element={<EmployeeExperiencePage />} />
          <Route path="/our-story" element={<CityWorthStoryPage />} />
          <Route path="/retention-calculator" element={<RetentionCalculatorPage />} />
          <Route path="/book-a-call" element={<BookACallPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
    </HelmetProvider>
  );
}

export default App;
